/** El dinero viaja en unidades menores (enteros). Aquí se convierte para el ojo. */

const SCALE: Record<string, number> = {
  AED: 2, USD: 2, EUR: 2, GBP: 2, SAR: 2, QAR: 2,
  KWD: 3, BHD: 3, OMR: 3, JPY: 0,
};

export const scaleOf = (currency: string): number => SCALE[currency] ?? 2;

export function money(minor: number, currency = 'AED', opts: { compact?: boolean } = {}): string {
  const scale = scaleOf(currency);
  const value = minor / 10 ** scale;
  try {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency,
      minimumFractionDigits: opts.compact ? 0 : scale,
      maximumFractionDigits: opts.compact ? 1 : scale,
      notation: opts.compact ? 'compact' : 'standard',
    }).format(value);
  } catch {
    return `${value.toLocaleString('es-ES')} ${currency}`;
  }
}

/** Solo la cifra, sin símbolo — para columnas donde la moneda va aparte. */
export function amount(minor: number, currency = 'AED'): string {
  const scale = scaleOf(currency);
  return new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: scale,
    maximumFractionDigits: scale,
  }).format(minor / 10 ** scale);
}

export function date(iso: string | null, style: 'short' | 'long' = 'short'): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: style === 'long' ? 'long' : '2-digit',
    year: 'numeric',
  });
}

export function relativeDays(days: number | null): string {
  if (days == null) return '—';
  if (days < 0) return `hace ${Math.abs(days)} días`;
  if (days === 0) return 'hoy';
  if (days === 1) return 'mañana';
  return `en ${days} días`;
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');
}

/** Color estable a partir de un identificador — para avatares de empresa. */
export function tone(seed: string): string {
  const palette = ['#205c3e', '#3a4a7a', '#7a4a2e', '#4a4a52', '#5a3a5e', '#2e5a5a'];
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) & 0xffff;
  return palette[h % palette.length]!;
}
